module.exports = __webpack_public_path__ + "static/media/jediparrot.aa1c6328.gif";